 import './view.scss';

// Hero module - no JavaScript needed for basic functionality

